export default {
    maxContentWidth: '100%',
    headerHeight: 154, // component + margins (8+8)
    headerHeightMobile: 120, // component + margins (8+8)
    overlayBodyTitleHeight: 50,
} as const;
